<nav class="sidebar" [class.collapsed]="collapsed()">
  <!-- Logo / Brand -->
  <div class="sidebar__brand">
    <div class="sidebar__logo">
      <span class="sidebar__logo-icon">IR</span>
      @if (!collapsed()) {
        <div class="sidebar__logo-text">
          <span class="sidebar__logo-name">Invento</span>
          <span class="sidebar__logo-sub">Rating Engine</span>
        </div>
      }
    </div>
    <button class="sidebar__collapse-btn" (click)="toggleCollapse.emit()" [title]="collapsed() ? 'Expand sidebar' : 'Collapse sidebar'">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        @if (collapsed()) {
          <polyline points="9 18 15 12 9 6"></polyline>
        } @else {
          <polyline points="15 18 9 12 15 6"></polyline>
        }
      </svg>
    </button>
  </div>

  <!-- Navigation -->
  <div class="sidebar__nav">

    <!-- Global nav items -->
    @for (item of globalNavItems; track item.id) {
      @if (item.dividerBefore) {
        <div class="sidebar__divider"></div>
      }
      <a
        class="sidebar__item"
        [routerLink]="item.route"
        routerLinkActive="active"
        [title]="collapsed() ? item.label : ''"
      >
        <span class="sidebar__item-icon">{{ item.icon }}</span>
        @if (!collapsed()) {
          <span class="sidebar__item-label">{{ item.label }}</span>
          @if (item.badge) {
            <span class="sidebar__item-badge">{{ item.badge }}</span>
          }
        } @else if (item.badge) {
          <span class="sidebar__item-badge sidebar__item-badge--dot"></span>
        }
      </a>
    }

    <!-- LOB-scoped nav items (visible only when inside a line of business) -->
    @for (item of lobNavItems(); track item.id) {
      @if (item.dividerBefore) {
        @if (!collapsed() && item.sectionLabel) {
          <span class="sidebar__section-label">{{ item.sectionLabel }}</span>
        }
        <div class="sidebar__divider"></div>
      }
      <a
        class="sidebar__item"
        [routerLink]="item.route"
        [queryParams]="item.queryParams ?? null"
        routerLinkActive="active"
        [title]="collapsed() ? item.label : ''"
      >
        <span class="sidebar__item-icon">{{ item.icon }}</span>
        @if (!collapsed()) {
          <span class="sidebar__item-label">{{ item.label }}</span>
        }
      </a>
    }

  </div>

  <!-- Footer -->
  <div class="sidebar__footer">
    @if (!collapsed()) {
      <div class="sidebar__user">
        <div class="sidebar__avatar">SM</div>
        <div class="sidebar__user-info">
          <span class="sidebar__user-name">Sarah Mitchell</span>
          <span class="sidebar__user-role">Senior Actuary</span>
        </div>
      </div>
    } @else {
      <div class="sidebar__avatar sidebar__avatar--centered">SM</div>
    }
  </div>
</nav>
